import logo from './logo.svg';
import './App.css';
import Portfolio from './Components/Portfolio';

function App() {
  return (
    <Portfolio/>
  );
}

export default App;
